import React, { ReactNode } from 'react';
import { Row } from './layout/Row';
import { IntlShape, useIntl } from 'react-intl';
import { WorkPersonDTO } from '../../../api/core';
import { InternalLink } from '../../components/InternalLink';
import { getNotation } from '../../../Vocabulary/util';
import { boolFilter } from '../../../Vocabulary/data';
import { Internal } from '../../edit/components/LinkedPerson';

interface Props {
  linkedPersons: Internal[];
  rolesListSubset?: string;
}

export const LinkedPerson: React.FC<Props> = (props: Props): ReactNode => {
  const intl: IntlShape = useIntl();
  return (
    <Row title={intl.formatMessage({ id: 'work.attr.persons.label' })}>
      {props.linkedPersons
        .sort((a: WorkPersonDTO, b: WorkPersonDTO): number => a.sequence - b.sequence)
        .map(
          (person: WorkPersonDTO, index: number): ReactNode => (
            <div key={index} className={'flex flex-column'}>
              <div className={'flex flex-row justify-content-between'}>
                <div>
                  <InternalLink to={`/person/${person.personName.personId}`}>
                    <strong>
                      {[person.personName.surname, person.personName.givenname].filter(Boolean).join(', ')}
                    </strong>
                  </InternalLink>
                </div>
                <div>
                  <small className={'white-space-nowrap'}>{`ID: ${person.personName.personId}`}</small>
                </div>
              </div>
              {person.personName.salutation && (
                <div>
                  {intl.formatMessage({ id: 'work.attr.person.attr.salutation.label' })}:{' '}
                  {getNotation('salutation_list', person.personName.salutation, intl.locale)}
                </div>
              )}
              {
                <div>
                  {intl.formatMessage({ id: 'work.attr.person.attr.isMain.label' })}:{' '}
                  {boolFilter(person.personName.isMain || false)}
                </div>
              }
              {person.topOrgas &&
                person.topOrgas.length > 0 &&
                (person.topOrgas || []).map((topOrga: string, idx: number, array: string[]) => (
                  <div key={index}>
                    {intl.formatMessage({ id: 'work.attr.person.attr.affiliation.label' })}
                    {array.length > 1 ? ` ${idx + 1}: ` : ': '}
                    {topOrga}
                  </div>
                ))}
              <div>{`${intl.formatMessage({ id: 'work.attr.person.attr.role.label' })}: ${getNotation('person_role_list', person.role, intl.locale, props.rolesListSubset)}`}</div>
              <div>{`${intl.formatMessage({ id: 'work.attr.person.attr.sequence.label' })}: ${person.sequence}`}</div>
            </div>
          )
        )}
    </Row>
  );
}
